import { useParams } from "react-router";
import ProductImage from "./SingleProduct/ProductImage";
import ProductDetails from "./SingleProduct/ProductDetails";
import ProductDesc from "./SingleProduct/ProductDesc";
import { Link } from "react-router-dom";
import useMenuData from "../../hooks/useMenuData";
import useCarouselData from "../../hooks/useCarouselData";
import { useContext, useEffect, useState } from "react";
import useShopData from "../../hooks/useShopData";
import ProductCard from "./ProductCard";
import { ContextProvider } from "../../../App";
import MetaInfo from "../../Meta/Meta-Info";
import ReviewRating from "./Reviews/ReviewRating";
import ItemCardShimmer from "../../Shimmer/ItemCardShimmer";
import { PiShoppingCartLight } from "react-icons/pi";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { CartButton } from "../../utils/constant";
import { useCart } from "./CartContext";

const ItemCard = () => {
  const { id, variantid } = useParams();
  const [currentIndex, setCurrentIndex] = useState(0); // Index of the first visible product
  const [productsToShow, setProductsToShow] = useState(4);
  const [iconSize, setIconSize] = useState();
  const paramId = id;
  const { menuData } = useMenuData(paramId);
  const { FilterProducts } = useShopData();
  const { newCart } = useCart();
  const [carouselData] = useCarouselData();
  const { showLoader, setShowLoader, selectedWishList, setOpenDrawer } =
    useContext(ContextProvider);

  // const [productData, setProductData] = useState([]);
  // console.log(paramId);
  // console.log(variantid);

  const {
    name,
    category,
    sub_category,
    product_description,
    benefits,
    how_To_Use,
    priceOptions,
  } = menuData;

  const ProductDescriptions = { product_description, benefits, how_To_Use };

  const removeNameSpaces = name?.replace(/[^a-zA-Z0-9]/g, "-").toLowerCase();
  const removeSubCatSpaces = sub_category
    ?.replace(/[^a-zA-Z0-9]/g, "-")
    .toLowerCase();
  const removeCategorySpaces = category?.catKey
    ?.replace(/[^a-zA-Z0-9]/g, "-")
    .toLowerCase();

  // Meta Variables

  const MetaTitle = `Buy ${menuData?.name} -  ${menuData?.category?.catKey} ${menuData?.id} | ND Health Shop`;

  const metaDesc = ` Buy ${menuData?.name} -  ${
    menuData?.category?.catKey
  } from ND Health Shop at ₹ ${Number(menuData?.actual_price).toFixed(
    2
  )}. Product ID : ${menuData?.id}. Order now `;

  const metaURL = `https://ndhealth.shop/${removeCategorySpaces}/${removeSubCatSpaces}-${id}-${removeNameSpaces}`;

  const showDrawer = () => {
    setOpenDrawer(true);
  };

  const getCarouseData = carouselData?.subCarousel.filter(
    (item) => item?.sub_category === sub_category
  );

  const getRelatedData = FilterProducts?.filter((data) => {
    return (
      data?.category?.catKey === category?.catKey &&
      data?.id !== Number(paramId)
    );
  });
  // console.log(getRelatedData);

  useEffect(() => {
    const timeId = setTimeout(() => {
      setShowLoader(false);
    }, 1000);

    return () => clearTimeout(timeId);
  }, []);

  // Responsive logic to adjust productsToShow based on screen size
  useEffect(() => {
    // const updateProductsToShow = () => {
    // if (window.innerWidth <= 660) {
    //   setProductsToShow(2);
    // } else if (window.innerWidth <= 800) {
    //   setProductsToShow(3);
    // } else if (window.innerWidth <= 1370) {
    //   setProductsToShow(4);
    // } else {
    setProductsToShow(getRelatedData?.length ?? getRelatedData?.length);
    // }
    // };

    // updateProductsToShow();
    // window.addEventListener("resize", updateProductsToShow);
    // return () => window.removeEventListener("resize", updateProductsToShow);
  }, [getRelatedData?.length]);

  const carouselId = getCarouseData?.[0]?.id;

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % getRelatedData.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - 1 < 0 ? getRelatedData.length - 1 : prevIndex - 1
    );
  };

  const visibleProducts = [];
  for (let i = 0; i < productsToShow; i++) {
    visibleProducts.push(
      getRelatedData[(currentIndex + i) % getRelatedData.length]
    );
  }

  return !menuData?.name || showLoader ? (
    <ItemCardShimmer />
  ) : (
    <div className=" md:px-10 md:py-5 sm:p-5 p-3 flex flex-col gap-10">
      <div className="flex flex-col md:gap-5 gap-3">
        <MetaInfo
          pageTitle={MetaTitle}
          pageDescription={metaDesc}
          pageKeywords={`${menuData?.name} , ${menuData?.category?.catKey} , ${menuData?.sub_category} ,${menuData?.productDetails?.specialityDesc1}`}
          ogTitle={MetaTitle}
          ogDescription={metaDesc}
          ogUrl={metaURL}
          ogImage={menuData?.image}
          canonicalUrl={metaURL}
          twitterTitle={MetaTitle}
          twitterDesc={metaDesc}
          twitterUrl={metaURL}
          twitterProductImage={menuData?.image}
        />

        {/* NavLinks for Routing */}
        <div className="hidden sm:block">
          <div className="flex py-5 gap-1 sm:text-base text-sm ">
            <Link to={"/"}>
              <p className="text-mediumGray"> Home </p>
            </Link>
            <Link to={"/productspage"}>
              <p className="text-mediumGray"> / Products </p>
            </Link>
            {/* <Link to={`/${sub_category}/${carouselId}`}>
              <p className="text-mediumGray"> / {sub_category}</p>
            </Link> */}
            <p>/ {name}</p>
          </div>
        </div>

        {/* Product Image and Details section */}

        <div className="flex sm:flex-row flex-col md:gap-5 gap-3 md:justify-center items-start w-full">
          <ProductImage menuData={menuData} />
          <ProductDetails
            menuData={menuData}
            selectedWishList={selectedWishList}
          />
          {/* <ProductPrice menuData={menuData} /> */}
        </div>

        {/* Product Description section */}

        {product_description?.length >= 1 && (
          <ProductDesc
            // productDesc={productDesc}
            ProductDescriptions={ProductDescriptions}
          />
        )}
      </div>
      {/* <ReviewRating /> */}

      {/***********   Related Products    **********/}

      <div>
        {getRelatedData.length > 0 && (
          <h3 className="md:text-3xl text-xl font-semibold">
            Related Products
          </h3>
        )}
        <div className="flex flex-col  gap-4 overflow-hidden relative">
          {/* Navigation Buttons */}
          <div className="w-full xs:block hidden absolute top-1/4 ">
            <button
              onClick={handlePrevious}
              className={`p-1 rounded-full bg-main text-white transition-all duration-700 ease-in-out absolute z-10 left-0 absoulte`}
            >
              <FiChevronLeft size={24} />
            </button>
            <button
              onClick={handleNext}
              className={`p-1 rounded-full bg-main text-white transition-all duration-700 ease-in-out absolute z-10 right-0 absoulte`}
            >
              <FiChevronRight size={24} />
            </button>
          </div>

          {/* Products */}
          <div className="flex justify-around gap-0 overflow-auto xs:overflow-hidden scrollbar-hide">
            {/* {console.log(visibleProducts)} */}
            {getRelatedData?.length &&
              visibleProducts?.map((product) => (
                <div key={product?.id} className="w-fit">
                  <ProductCard product={product} />
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* Float cart Button */}
      {newCart?.length > 0 && (
        <CartButton
          styling={
            "fixed right-7 top-[50%] z-10 sm:block hidden text-black bg-white p-1 border rounded-full animate-bounce flex items-center justify-center cursor-pointer"
          }
          newCart={newCart}
          PiShoppingCartLight={PiShoppingCartLight}
          showDrawer={showDrawer}
        />
      )}
    </div>
  );
};

export default ItemCard;
